if (!customElements.get('rubbie-recently-viewed')) {
  customElements.define(
    'rubbie-recently-viewed',
    class RubbieRecentlyViewed extends HTMLElement {
      static STORAGE_KEY = 'rubbie:recently-viewed';
      static MAX_STORED = 12;

      connectedCallback() {
        const current = this.dataset.current;
        const stored = this.read();
        const handles = stored.filter((handle) => handle !== current);

        if (current) this.write([current, ...handles]);
        if (window.Shopify && window.Shopify.designMode) return;

        const limit = parseInt(this.dataset.limit, 10) || 4;
        this.render(handles.slice(0, limit));
      }

      read() {
        try {
          const value = JSON.parse(localStorage.getItem(RubbieRecentlyViewed.STORAGE_KEY));
          return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
        } catch (error) {
          return [];
        }
      }

      write(handles) {
        try {
          localStorage.setItem(
            RubbieRecentlyViewed.STORAGE_KEY,
            JSON.stringify(handles.slice(0, RubbieRecentlyViewed.MAX_STORED))
          );
        } catch (error) {}
      }

      async render(handles) {
        if (!handles.length) return;

        const root = this.dataset.root.endsWith('/') ? this.dataset.root : `${this.dataset.root}/`;
        const results = await Promise.all(
          handles.map((handle) =>
            fetch(`${root}products/${encodeURIComponent(handle)}?section_id=rubbie-product-card`)
              .then((response) => (response.ok ? response.text() : ''))
              .catch(() => '')
          )
        );

        const list = this.querySelector('[data-recently-viewed-list]');
        const valid = [];
        const fragment = document.createDocumentFragment();

        results.forEach((html, index) => {
          const item = new DOMParser().parseFromString(html, 'text/html').querySelector('.grid__item');
          if (!item) return;
          valid.push(handles[index]);
          fragment.appendChild(item);
        });

        if (valid.length !== handles.length) {
          const missing = handles.filter((handle) => !valid.includes(handle));
          this.write(this.read().filter((handle) => !missing.includes(handle)));
        }

        if (!fragment.childNodes.length) return;
        list.replaceChildren(fragment);
        this.hidden = false;
      }
    }
  );
}
